module.exports = __webpack_public_path__ + "static/media/clyde1941.2b1eb08f.png";